import m from "../../geodata/es2015/albaniaLow";
window.am4geodata_albaniaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/albaniaLow.js
// module id = null
// module chunks = 